import { makeStyles, createStyles } from '@material-ui/core'

export const useProjectDetailsStyles = makeStyles((theme) =>
  createStyles({
    buttonGroup: {
      display: 'flex',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(12),

      '& > button:not(:last-child)': {
        marginRight: theme.spacing(2)
      },

      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',

        '& > button:not(:last-child)': {
          marginRight: 0,
          marginBottom: theme.spacing(2)
        }
      }
    },

    similarCompanies: {
      width: '100%',
      textAlign: 'center'
    },

    cards: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center'
    },

    seoBlock: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },

    readMoreButton: {
      marginTop: 20,
      color: '#2e86bd',
      fontSize: 14,
      textDecoration: 'underline',
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer'
    },

    seoTitle: {
      marginBottom: '45px',
      fontSize: '18px',
      fontWeight: 500,
      [theme.breakpoints.down(960)]: {
        fontSize: '16px'
      }
    },

    seoDescription: {
      margin: 0,
      fontSize: '16px',
      [theme.breakpoints.down(960)]: {
        fontSize: '14px'
      }
    },

    nameBlock: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    name: {
      cursor: 'pointer',
      transition: '0.3s'
    },

    iconName: {
      transform: 'scale(2)',
      marginLeft: 10,
      marginRight: 30,
      [theme.breakpoints.down(960)]: {
        transform: 'scale(1.8)'
      }
    },

    crown: {
      position: 'absolute',
      left: 20,
      top: '-20px'
    },

    avatarUrl: {
      height: '45px',
      width: '45px',
      borderRadius: '50%',
      marginRight: '12px'
    }
  })
)
